export const mimeTypes = {
    "text/csv": "csv",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.ms-excel": "xls",
};

export function downloadFile(response, name = "file") {
    const blob = new Blob([response.data], {
        type: "application/octet-stream",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = getFilenameFromContentDisposition(response.headers, name);
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}

export function getFilenameFromContentDisposition(header, fileName) {
    const contentDisposition = header.get("Content-Disposition");
    const contentType = header.get("Content-Type");
    const typeFile = mimeTypes[contentType];

    if (contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);

        if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, "");
        }
    } else if (typeFile) {
        return `${fileName}.${typeFile}`;
    }

    return null;
}
